<template lang="pug">
.smsProgram
  .arrow_icon(@click="$router.go(-1)")
    img(src="@/assets/images/arrow_left.svg", alt="alt")
  h1 
    span(v-if="$root.member.name") 修改姓名
    span(v-else) 就快完成了
  p 請輸入真實姓名
  form.control-group
    input.ipt-box(type="text", v-model="name" placeholder="你的真實姓名") 
  .button-region
    button.stepNext(type="button" @click="setMemberName" :class="{active: name}") 
      .step-txt 下一步
</template>

<script>
export default {
  name: "sms-program",
  components: {},
  data () {
    return {
      name: "",
      editModel: false
    };
  },
  mounted () {
    if (this.$route.name === 'ChangeName') {
      this.editModel = true
    }
  },
  created () {
  },
  methods: {
    setMemberName () {
      if (!this.name) {
        return
      }
      console.log('=> 請求更新用戶名稱')
      let vm = this
      this.$root.apis.setUserName(
        this.$root.member.user_lineId,
        this.name,
        function (_response) {
          let member = _response.body.data
          vm.$root.member = member
          // 前往會員中心
          if (vm.editModel) {
            alert('姓名修改成功')
            vm.$root.goPage('/member-center')
          }

          // 前往同意條款
          else {
            vm.$root.goPage('/agree-terms')
          }
        }
      )
    }
  }
};
</script>
<style lang="sass" scoped>
.smsProgram
  background-color: #000
  position: relative
  .arrow_icon
    position: absolute
    top: 6vmin
    left: 6.1vmin
  h1
    font-size: 9vmin
    text-align: center
    color: #fff
    padding-top: 34.25vmin
  p
    font-size: 5vmin
    text-align: center
    color: #fff
    margin-top: 6.5vmin
  .control-group
    width: 95%
    margin: auto
    display: flex
    justify-content: center
    align-items: center
    gap: 2.5vmin
    margin-top: 10vh
    .ipt-box
      width: 53.75vmin
      background-color: #000
      font-weight: 400
      font-size: 5vmin
      color: #fff
      border: 1px solid #505251
      padding: 3.5vmin 6vmin
      border-radius: 25vmin
      &:focus
        border: 1.5px solid #22F48F;
.button-region
  margin: 0px auto
  padding-top: 15%
  text-align: center
.stepNext
  margin: 0px auto
  width: 53.75vmin
  border-radius: 12.5vmin
  background-color: #898A8D
  border: none
  padding: 3vmin 0px
  &.active
      background-color: #22F48F
  .step-txt
    text-align: center
    font-size: 6vmin
    font-weight: 700
    color: #1E1E1E
</style>
